import { Environment } from '@shared/interfaces/environment';
import { RoutesPath } from '@shared/enums/routes-path';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';

export const environment: Environment = {
  production: true,
  langs: {
    fr: {
      host: 'scan-vin.com',
      langs: ['fr', 'en', 'es'],
      defaultLang: 'fr',
      countryCode: ['fr'],
      plate: {
        code: 'f',
        placeholder: 'AB-123-CD',
      },
      api: {
        url: 'https://api.scan-vin.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD2fE0fYj7pcB_uCdY66T8co4PEZmVLe_4',
        },
      },
      sentry: {
        dsn: 'https://02488f3ab393a296a9a6dcebaceb80b3@o4508637161783296.ingest.de.sentry.io/4508698689536080',
      },
      config: {
        name: 'Scan VIN',
        test: false,
        subscription: {
          name: 'Scan VIN+',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787318',
          vat: 'BG207787318',
          address: 'Barzaritsa Street, 4A, ap.16, 1618 Sofia, Bulgaria',
          name: 'SRS MEDIA LTD',
        },
        partners: [],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'connexion-utilisateur',
        [RoutesPath.SIGN_UP]: 'nouveau-compte',
        [RoutesPath.UNSUBSCRIBE]: 'desinscription',
        [RoutesPath.FORGOT_PASSWORD]: 'mdp-oublie',
        [RoutesPath.RESET_PASSWORD]: 'redefinir-mot-de-passe',
        [RoutesPath.CONTACT]: 'aide-et-contact',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'compte-personnel',
        [RoutesPath.NOT_FOUND]: 'erreur-page',
        [RoutesPath.ABOUT]: 'a-propos-de-nous',
        [RoutesPath.PREVIEW]: 'voir-exemple',
        [RoutesPath.PAYMENT_INTENT]: 'etape-paiement',
        [RoutesPath.PAYMENT_VALIDATION]: 'paiement-ok',
        [RoutesPath.LOADING]: 'analyse-en-cours',
        [RoutesPath.LOADING_PREVIEW]: 'chargement-rapport',
        [RoutesPath.PRICING]: 'tarification',
        [RoutesPath.CAREERS]: 'offres-emploi',
        [RoutesPath.COMPANY]: 'espace-pro',
        [RoutesPath.SERVICE]: 'fiche-vehicule',
        [RoutesPath.GLOSSARY]: 'lexique-auto',
        [RoutesPath.GUIDE]: 'conseils-utilisation',
        [RoutesPath.PRESS]: 'presse-et-medias',
        [RoutesPath.SSO]: 'magiclink',
        [RoutesPath.CAR_NOT_FOUND]: 'aucune-voiture',
        [RoutesPath.TESTIMONIALS]: 'temoignages-clients',
        [RoutesPath.SERVICES]: 'nos-services',
        [RoutesPath.ARTICLES]: 'actualites-auto',
        [RoutesPath.VIN]: 'decoder-numero-vin',
        [RoutesPath.COMPARE]: 'avantages-comparatifs',
        [RoutesPath.PARTNERS]: 'partenaires',
        [RoutesPath.AFFILIATE]: 'devenir-affilie',
        [RoutesPath.LEASING]: 'location-longue-duree',
        [RoutesPath.INSURANCE]: 'infos-assurance',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'mentions-legales',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politique-de-confidentialite',
        [GlobalRoutesPath.REFUND_POLICY]: 'politique-de-remboursement',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'conditions-generales',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'conditions-generales-de-vente',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'faq',
      },
      serviceRoutes: {},
      articleRoutes: {},
    },
  },
};
